import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/assinatura-eletronica`

    return {
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        loadFields(queryParms = {}) {

            return repository.get(`${baseUrl}/load-field?${urlUtil.serialize(queryParms)}`)
        },
        getAtendimento(queryParms = {}) {

            return repository.get(`${baseUrl}/atendimento?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
    }
}
